import messages from './netbank-login-account-number-lang.json';
import { required, minLength } from 'vuelidate/lib/validators';
import accountNumberLength from '../../../common/js/validators/account-number-length';
import netbankLoginFormBase from '../netbank-login-form-base/netbank-login-form-base';
const COOKIE_USER_DATA_NAME = 'portal-netbank-login-account';
const COOKIE_ADDITIONAL_NAME = 'portal-netbank-login-account-additional';
import { COOKIE_PORTAL_ID_NAME } from './../../../common/js/constants/constants';
import VueCheckbox from '@ui-common/vue-checkbox';
export default {
	extends: netbankLoginFormBase,
	data() {
		return {
			model: {
				accountNumber: null
			}
		};
	},
	i18n: { messages },
	validations() {
		return {
			model: {
				identifier: {
					required,
					minLength: minLength(4)
				},
				accountNumber: {
					required,
					accountNumberLength
				},
				password: {
					required
				}
			}
		};
	},
	props: {
		otpdirektUrl: {
			required: true
		},
		linkError: {
			required: true
		}
	},
	computed: {
		hasEditedError() {
			return this.$slots.default;
		}
	},
	components: {
		VueCheckbox
	},
	methods: {
		jumpToAccountNumber() {
			this.$refs['account-number'].$refs['account-number-input'].focus();
		},
		showFieldErrors() {
			this.$v.model.identifier.$touch();
			this.$v.model.accountNumber.$touch();
			this.$v.model.password.$touch();

			if (this.$v.model.identifier.$invalid && this.$v.model.accountNumber.$invalid && this.$v.model.password.$invalid) {
				this.$gtm.trackEvent({
					event: 'direktBankLoginFailed',
					loginType: 'accountNumber',
					loginDetails: 'invalidForm'
				});
			}
		},
		submitForm() {
			this.$gtm.trackEvent({
				event: 'direktBankLogin',
				loginType: 'accountNumber'
			});
			let accountNumberParts = this.model.accountNumber.split('-');
			this.$refs.accountNumber0.value = `117${accountNumberParts[0]}`;
			this.$refs.accountNumber1.value = accountNumberParts[1];
			this.$refs.accountNumber2.value = accountNumberParts[2] ? accountNumberParts[2] : '';
			this.$refs.identifier.value = this.model.identifier;
			this.$refs.tranzakcionkentiAzonositas.value = this.model.identifyTransaction ? 'on' : '';
			this.$refs.password.value = this.model.password;
			this.$refs.isContextData.value = this.seonData || '';
			if (this.structureId) {
				this.$refs.structureId.value = this.structureId;
			}
			let cookieId = this.$cookie.get(COOKIE_PORTAL_ID_NAME);
			this.$refs.cookieId.value = cookieId;
			this.$refs.lang.value = this.$i18n.locale;
			this.$refs.hiddenForm.submit();
		}
	},
	created() {
		this.cookiePortalIdName = COOKIE_PORTAL_ID_NAME;
		this.cookieUserDataName = COOKIE_USER_DATA_NAME;
		this.cookieAdditionalName = COOKIE_ADDITIONAL_NAME;
		this.loadCookie();
	}
};
